import React from "react";
import clsx from "clsx";
import RoomTypeBuilderCategories from "./RoomTypeBuilderCategories"
import RoomTypeBuilderOrder from "./RoomTypeBuilderOrder"
import Tabs from "../../Tabs/Tabs";

class RoomTypeBuilderAmenities extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      amenities_active_tab: "categories"
    }
    this.onChangeActiveAmenityTab = this.onChangeActiveAmenityTab.bind(this);
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'amenities',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="amenities">
        <div className="panel panel-default">
          <div className="panel-body container">
            <h3 className="panel-heading-text">{I18n.t("amenities")}</h3>
            <div className="table-wrap-panel" >
              <Tabs tabs={this.amenityTabs()} />
                <br className="embedded-table-tabs-br"/>
                {this.state.amenities_active_tab === 'categories' ? <RoomTypeBuilderCategories {...this.props} amenities_active_tab={this.state.amenities_active_tab}/> : null}
                {this.state.amenities_active_tab === 'order' ? <RoomTypeBuilderOrder {...this.props} amenities_active_tab={this.state.amenities_active_tab}/> : null}
            </div>
          </div>
        </div>
      </div>
    );
  };

  onChangeActiveAmenityTab(tab) {
    if (tab) {
      this.setState({
        amenities_active_tab: tab,
      });
    };
  };

  amenityTabs() {
    return (
      [
        {
          tabName: I18n.t('categories'),
          targetName: 'categories',
          classes: this.state.amenities_active_tab === 'categories' ? 'active' : null,
          changeHandler: this.onChangeActiveAmenityTab,
        },
        {
          tabName: I18n.t('order'),
          targetName: 'order',
          classes: this.state.amenities_active_tab === 'order' ? 'active' : null,
          changeHandler: this.onChangeActiveAmenityTab,
        },
      ]
    );
  };
};

export default RoomTypeBuilderAmenities